// src/features/signature/logic.ts
// Status/role → label and badge-variant mapping for the signature module.
// See docs/ux/signature-ia.md.

import type { PartyStatus, SignatureStatus } from '@core/types/signature';

export function enumSuffix(value: string | undefined, prefix: string): string {
  if (!value) return 'unspecified';
  return value.startsWith(prefix) ? value.slice(prefix.length).toLowerCase() : value.toLowerCase();
}

export function partyStatusVariant(status?: PartyStatus): string {
  switch (status) {
    case 'PARTY_STATUS_SIGNED': return 'success';
    case 'PARTY_STATUS_DECLINED':
    case 'PARTY_STATUS_REVOKED': return 'error';
    case 'PARTY_STATUS_VIEWED':
    case 'PARTY_STATUS_INVITED': return 'info';
    default: return 'default';
  }
}

export function signatureStatusVariant(status?: SignatureStatus): string {
  switch (status) {
    case 'SIGNATURE_STATUS_VALID': return 'success';
    case 'SIGNATURE_STATUS_REVOKED': return 'error';
    case 'SIGNATURE_STATUS_SUPERSEDED': return 'warning';
    default: return 'default';
  }
}
